<template>
	<div class="d-flex nav-container">
		<v-navigation-drawer
			permanent
			stateless
			:mini-variant="false"
			width="256"
			class="navigation-drawer"
		>
			<img
				:src="logoSrc"
				class="ma-4 mb-3 nav-full-logo"
			>
			<v-list
				nav
				dense
			>
				<template v-for="link in links">
					<v-list-item
						v-if="!link.sublinks || link.sublinks.length === 0"
						:key="link.text"
						:to="link.customAction ? undefined : link.route"
						:link="!link.customAction"
						@click="triggerCustomAction(link.customAction)"
					>
						<v-list-item-title
							class="syrenis-black--text"
						>
							<v-icon
								class="nav-icon-color--text mr-3"
								dense
							>
								{{ link.icon }}
							</v-icon>
							<span class="nav-text-with-chip">
								<span>
									{{ link.text | useLabels }}
								</span>
								<Chip
									v-if="link.chipLabel"
									class="nav-chip"
									:color="chipColor"
									text-color="white"
								>
									{{ link.chipLabel }}
								</Chip>
							</span>
						</v-list-item-title>
					</v-list-item>
					<v-list-group
						v-else
						ref="mainListGroups"
						:key="link.text"
						link
						:ripple="false"
					>
						<v-list-item-content
							slot="activator"
							color="syrenis-black"
						>
							<v-list-item-title
								class="syrenis-black--text"
							>
								<v-icon
									class="nav-icon-color--text mr-3"
									dense
								>
									{{ link.icon }}
								</v-icon>
								<span class="nav-text-with-chip">
									<span>
										{{ link.text | useLabels }}
									</span>
									<Chip
										v-if="link.chipLabel"
										class="nav-chip"
										:color="chipColor"
										text-color="white"
									>
										{{ link.chipLabel }}
									</Chip>
								</span>
							</v-list-item-title>
						</v-list-item-content>
						<template v-for="sublink in link.sublinks">
							<v-list-item
								v-if="!sublink.deeperSublinks || sublink.deeperSublinks.length == 0"
								:key="sublink.text"
								:to="sublink.customAction ? undefined : sublink.route"
								:link="!sublink.customAction"
								@click="triggerCustomAction(sublink.customAction)"
							>
								<v-list-item-title
									class="syrenis-black--text ml-4"
								>
									<span class="nav-text-with-chip">
										<span>
											{{ sublink.text | useLabels }}
										</span>
										<Chip
											v-if="sublink.chipLabel"
											class="nav-chip"
											:color="chipColor"
											text-color="white"
										>
											{{ sublink.chipLabel }}
										</Chip>
									</span>
								</v-list-item-title>
							</v-list-item>
							<v-list-group
								v-else
								ref="subListGroups"
								:key="sublink.text"
								sub-group
								class="syrenis-nav-sub-group"
								prepend-icon="$expand"
								:ripple="false"
							>
								<v-list-item-content
									slot="activator"
									color="indigo"
								>
									<v-list-item-title
										class="syrenis-black--text ml-4"
									>
										<span class="nav-text-with-chip">
											<span>
												{{ sublink.text | useLabels }}
											</span>
											<Chip
												v-if="sublink.chipLabel"
												class="nav-chip"
												:color="chipColor"
												text-color="white"
											>
												{{ sublink.chipLabel }}
											</Chip>
										</span>
									</v-list-item-title>
								</v-list-item-content>
								<v-list-item
									v-for="deeperSublink in sublink.deeperSublinks"
									:key="deeperSublink.text"
									:to="deeperSublink.customAction ? undefined : deeperSublink.route"
									:link="!deeperSublink.customAction"
									@click="triggerCustomAction(deeperSublink.customAction)"
								>
									<v-list-item-title
										class="syrenis-black--text ml-8"
									>
										<span class="nav-text-with-chip">
											<span>
												{{ deeperSublink.text | useLabels }}
											</span>
											<Chip
												v-if="deeperSublink.chipLabel"
												class="nav-chip"
												:color="chipColor"
												text-color="white"
											>
												{{ deeperSublink.chipLabel }}
											</Chip>
										</span>
									</v-list-item-title>
								</v-list-item>
							</v-list-group>
						</template>
					</v-list-group>
				</template>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
import Chip from './chip.vue'
import logoLight from '../assets/Syrenis-Black.svg'
import logoDark from '../assets/Syrenis-red.svg'

export default {
	components: { Chip },
	props: {
		links: {
			type: Array,
			default: () => []
		},
		changeShowFilters: {
			type: Function,
			default: () => {}
		},
		resetAdminPortalFilters: {
			type: Function,
			default: () => {}
		}
	},
	computed: {
		logoSrc () {
			return this.$vuetify.theme.dark ? logoDark : logoLight
		},
		chipColor () {
			return this.$vuetify.theme.dark ? 'syrenis-red' : 'steel-blue'
		}
	},
	methods: {
		triggerCustomAction (action) {
			this.resetFilters()
			if (!action) return
			action()
		},
		resetFilters () {
			this.changeShowFilters(false)
			this.resetAdminPortalFilters()
		}
	}
}
</script>
<style>
/* Navigation drawer icon styles */
.v-navigation-drawer .v-list-group__header__append-icon .v-icon,
.v-navigation-drawer .v-list-group__header__append-icon .v-icon__svg,
.v-navigation-drawer .syrenis-nav-sub-group .v-list-group__header__prepend-icon .v-icon,
.v-navigation-drawer .syrenis-nav-sub-group .v-list-group__header__prepend-icon .v-icon__svg {
	fill: var(--global-syrenis-black) !important;
	color: var(--global-syrenis-black) !important;
}

/* Smaller expansion arrows */
.v-navigation-drawer .v-list-group__header__append-icon .v-icon {
	font-size: 18px !important;
}

.v-navigation-drawer .syrenis-nav-sub-group .v-list-group__header__prepend-icon .v-icon {
	font-size: 18px !important;
}

/* Dark mode nav icon and text visibility */
.dark .v-navigation-drawer .v-icon,
.dark .v-navigation-drawer .v-icon__svg {
	color: var(--global-foreground, #f7fafc) !important;
	fill: var(--global-foreground, #f7fafc) !important;
}

.dark .v-navigation-drawer .syrenis-black--text,
.dark .v-navigation-drawer .v-list-item-title {
	color: var(--global-foreground, #f7fafc) !important;
}

/* Navigation item spacing */
.v-navigation-drawer .v-list-item,
.v-navigation-drawer .v-list-group__header {
	min-height: 44px !important;
	height: 44px !important;
	padding: 12px 12px !important;
	/* margin-bottom: 2px; */
	border-radius: var(--radius, 8px);
}

.v-navigation-drawer .v-list-item:hover,
.v-navigation-drawer .v-list-item--link:before {
	background: var(--global-table-row-hover, rgba(0, 0, 0, 0.04));
}

/* Dark mode: remove hover and active backgrounds for consistent nav appearance */
.dark .v-navigation-drawer .v-list-item:hover,
.dark .v-navigation-drawer .v-list-item--active::before,
.dark .v-navigation-drawer .v-list-item--link:before,
.dark .v-navigation-drawer .v-list-item--active:hover::before {
	background: transparent !important;
}

.dark .v-navigation-drawer .v-list-item--active {
	background-color: transparent !important;
}

.v-navigation-drawer .syrenis-nav-sub-group .v-list-group__header {
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.v-navigation-drawer .syrenis-nav-sub-group .v-list-group__header__prepend-icon {
	order: 1;
	margin-left: auto;
	margin-right: -6px !important;
	align-self: center;
}

/* Logo styles */
.nav-full-logo {
	max-width: 144px;
	height: auto;
}

/* Nav container styles */
.nav-container {
	position: relative;
	background-color: var(--global-nav-background, #ffffff);
}

.navigation-drawer {
	background-color: var(--global-nav-background, #ffffff) !important;
	box-shadow: 2px 0 8px 0 rgba(0,0,0,0.1) !important;
	z-index: 2;
	position: relative;
	overflow: visible;
}

.dark .navigation-drawer {
	box-shadow: 2px 0 8px 0 rgba(0,0,0,0.2) !important;
}

/* Hide the border/resize handle that acts as a collapse trigger */
.navigation-drawer .v-navigation-drawer__border {
	display: none !important;
}

/* Navigation item text styling */
.v-navigation-drawer .v-list-item__title,
.v-navigation-drawer .v-list-item__title span {
	font-size: 0.875rem !important; /* 14px */
	font-weight: 400 !important; /* Normal weight */
	line-height: 1.25rem !important; /* 20px */
	letter-spacing: normal !important;
}

/* Active/selected navigation item styling */
.v-navigation-drawer .v-list-item--active .v-list-item__title {
	font-weight: 600 !important; /* Semi-bold for active items */
}

/* Hover state for navigation items */
.v-navigation-drawer .v-list-item:hover .v-list-item__title {
	font-weight: 500 !important; /* Medium weight on hover */
}

.nav-text-with-chip {
	display: inline-flex;
	align-items: center;
	gap: 6px;
}

.nav-chip {
	font-size: 9px !important;
	font-weight: 600 !important;
	letter-spacing: 0.3px !important;
	text-transform: uppercase !important;
	height: 16px !important;
	min-height: 16px !important;
	padding: 0 6px !important;
	border-radius: 8px !important;
	line-height: 16px !important;
}

.nav-chip.v-chip.v-size--x-small {
	font-size: 9px !important;
	height: 16px !important;
}

/* Additional specificity for Vuetify chip overrides */
.v-navigation-drawer .nav-chip.v-chip,
.v-navigation-drawer .nav-chip.v-chip.v-size--x-small,
.v-navigation-drawer .v-chip.nav-chip {
	font-size: 9px !important;
	height: 16px !important;
	min-height: 16px !important;
	padding: 0 10px !important;
	line-height: 16px !important;
	border-radius: 999px !important;
}

.v-navigation-drawer .nav-chip.v-chip .v-chip__content {
	font-size: 9px !important;
	line-height: 16px !important;
	padding: 0 !important;
}
</style>
